<template>
  <div class="main-menu menu-fixed" style="top: 122px">
    <SideBarSetting
      v-if="currentRouteName.includes('settings-user-management')"
    />
    <SideBarPromo v-if="currentRouteName.includes('promotions')" />
    <SideBarMarketing v-if="currentRouteName.includes('marketing')" />
    <SideBarReport v-if="currentRouteName.includes('report')" />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import SideBarSetting from "@/views/apps/settings/SideBarSetting.vue";
import SideBarPromo from "./SideBarPromo.vue";
import SideBarMarketing from "./SideBarMarketing.vue";
import SideBarReport from "./SideBarReport.vue";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    SideBarSetting,
    SideBarPromo,
    SideBarMarketing,
    SideBarReport,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      settingMenuItems: [
        { route: "user-management", title: "Admins & Roles" },
        { route: "affiliates", title: "Affiliates" },
      ],
    };
  },
  computed: {
    navMenuItems() {
      return this.settingMenuItems;
    },
    currentRouteName() {
      return typeof this.$router.currentRoute?.name === "string"
        ? this.$router.currentRoute.name
        : "";
    },
  },
  setup(props) {
    const { isMouseHovered, collapseTogglerIcon, updateMouseHovered } =
      useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    // App Name
    const { appLogoImage } = $themeConfig.app;

    return {
      // navMenuItems,
      perfectScrollbarSettings,
      collapseTogglerIcon,
      isMouseHovered,
      updateMouseHovered,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Logo
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
